import MUIBox, { BoxProps } from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

import Loader from 'src/common/components/Loader';

type Props = BoxProps & {
  isLoading?: boolean;
  /** Grow to fill remaining viewport; table/grid scrolls inside (no page scrollbar). */
  fill?: boolean;
  /** With `fill`, allow this box to scroll (e.g. stacked sections). Default: clip and scroll children. */
  scrollable?: boolean;
};

const PageBox = ({ isLoading, children, fill = false, scrollable = false, sx, ...props }: Props) => {
  const sxProp: SxProps<Theme> = [
    {
      position: 'relative',
      width: '100%',
      mb: fill ? 0 : 2,
    },
    fill
      ? {
          flex: '1 1 0',
          minHeight: 0,
          overflow: scrollable ? 'auto' : 'hidden',
          display: 'flex',
          flexDirection: 'column',
          ...(scrollable ? { pb: 2 } : {}),
        }
      : {},
    ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
  ];

  return (
    <MUIBox sx={sxProp} {...props}>
      {isLoading ? <Loader isLoading={isLoading} height="300px" /> : children}
    </MUIBox>
  );
};

export default PageBox;
